import { useState } from "react";
import { CampaignData } from "../store/dashboardStore";
import Button from "@/components/ui/Button";

interface IconItem {
  src: string;
  alt: string;
  number: number | string;
}

interface CampaignCardProps {
  imageUrl: string;
  icons?: IconItem[][];
  onViewClick: () => void;
  data: CampaignData;
}

export default function CampaignCard({
  imageUrl,
  icons = [],
  onViewClick,
  data,
}: CampaignCardProps) {
  const [hover, setHover] = useState(false);
  return (
    <div>
      <div className="mb-3">
        <div className="flex justify-between">
          <div className="underline text-sm">
            <div className="underline text-sm">
              {data.teams.find((e) => e.team_type === "client")?.name || "N.A"}
            </div>
          </div>
          <div className="text-gray-400 text-sm">
            {data.campaign.project_code}
          </div>
        </div>
        <div className="text-base mt-3">{data.campaign.name}</div>
      </div>
      <div
        className="bg-cover bg-no-repeat bg-center w-full rounded-2xl relative hover-card h-[330px]"
        style={{ backgroundImage: `url(${imageUrl})` }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div
          className={`w-full h-full p-0 transition-opacity duration-300 absolute inset-0 rounded-2xl hover-overlay ${
            hover ? "opacity-100 bg-black bg-opacity-70" : "opacity-0"
          }`}
        >
          <div className="p-0 flex w-full h-full flex-col gap-10 justify-center items-center card-drop rounded-2xl">
            <div className="flex w-full justify-center gap-3 z-10 relative">
              {icons.map((iconGroup, idx) => (
                <div
                  key={idx}
                  className="flex flex-col gap-3 items-center justify-center"
                >
                  {iconGroup.map(({ src, alt, number }, i) => (
                    <div key={i} className="flex mr-3">
                      <img
                        src={src}
                        alt={alt}
                        className="w-8 h-8 filter drop-shadow-lg"
                      />
                      <p className="w-8 h-8 flex justify-center items-center text-white">
                        {number}
                      </p>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <Button
              className="z-10 relative border-none"
              type="primary"
              onClick={onViewClick}
            >
              View Campaign
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
